<template>
  <div
    :class="[
      'h-full flex flex-col p-2 md:p-4 large:p-6 pb-12 justify-between',
      sidebarStore.isSidebarCollapsed ? 'items-center' : 'items-start',
    ]"
  >
      <div class="flex items-center gap-4 py-6">
        <div
          v-if="sidebarStore.isSidebarCollapsed || isSmallScreen"
          class="flex justify-center w-full"
          v-html="sidebarLvedLogo"
        ></div>
        <div v-else class="flex-1 flex justify-center items-center h-6">
          <div class="flex items-center gap-2">
            <div v-html="sidebarLved" class="h-full w-auto"></div>
          </div>
        </div>
    </div>

    <nav
      class="flex-1 py-4 overflow-y-auto w-full hide-scroll"
      id="sidebar-dashboard-item"
    >
      <div class="space-y-1 md:space-y-2 large:space-y-8">
        <template v-if="loading">
          <BaseSkeleton
            v-for="n in 5"
            :key="n"
            width="15rem"
            height="3rem"
            wrapper-class="flex-shrink-0 rounded-2xl"
          />
        </template>
        <template v-else>
          <router-link
            v-for="item in menuItems"
            :key="item.id"
            :to="item.path"
            class="flex transition-colors no-underline w-full h-[45px] large:h-[50px] rounded-xl hover:bg-activeBg"
            active-class="bg-activeBg text-btnActive"
            v-slot="{ isActive }"
          >
            <div
              :class="[
                'flex items-center w-full h-full py-0 large:py-1',
                sidebarStore.isSidebarCollapsed
                  ? 'justify-center'
                  : 'gap-2 md:gap-2 large:gap-4 pl-2 pr-3',
              ]"
            >
              <div 
                v-if="isSvgIcon(item.icon)" 
                v-html="item.icon" 
                class="w-6 h-6 flex-shrink-0"
                :aria-label="`Icon-${item.label}`"
              ></div>
              
              <img 
                v-else
                :src="item.icon" 
                class="w-6 h-6 flex-shrink-0" 
                :alt="`Icon-${item.label}`" 
              />
              
              <span
                v-if="!sidebarStore.isSidebarCollapsed"
                :class="[
                  'font-just md:text-h6 large:text-h4 font-500 leading-normal hover:text-btnActive',
                  isActive ? 'text-btnActive' : 'text-softGray',
                ]"
                >{{ item.label }}</span
              >
            </div>
          </router-link>
        </template>
      </div>
    </nav>

    <div
      v-if="!isSmallScreen && !sidebarStore.isSidebarCollapsed"
      class="mb-[48px]"
    >
    </div>
  </div>
</template>

<script setup>
import { sidebarLved } from "@/utils/commonSvg";
import { useSidebarStore,useRightPanelStore } from "@/stores/layoutStore";
import { ref, onMounted, onUnmounted } from "vue";
import { useNavigationMenu } from "@/composables/useNavigationMenu";

// Store instances
const sidebarStore = useSidebarStore();
const rightPanelStore = useRightPanelStore();

// Responsive screen check
const isSmallScreen = ref(window.innerWidth < 768);

// Loading state
const loading = ref(true);

// Update on screen resize
const handleResize = () => {
  isSmallScreen.value = window.innerWidth < 768;
};

onMounted(async () => {
  window.addEventListener("resize", handleResize);
  loading.value = false;
});

// Cleanup on unmount
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

// Use navigation menu composable
const { menuItems } = useNavigationMenu(rightPanelStore);

const isSvgIcon = (icon) => {
  if (!icon) return false;
  return typeof icon === 'string' && (icon.trim().startsWith('<') || icon.includes('<svg'));
};

</script>
